import { CloseIcon } from '@sketchnote/icons';
import { useRef, useState } from 'react';

import { useAgileStore } from '../../store';

interface SprintProps {
  onClose: () => void;
}

export const Sprint = ({ onClose }: SprintProps) => {
  const [isSaving, setSaving] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const addSprint = useAgileStore((s) => s.addSprint);
  const [errors, setErrors] = useState({
    name: '',
    description: '',
  });

  const handleSprint = async (e) => {
    e.preventDefault();
    if (isSaving) return;
    if (inputRef.current?.value.trim() === '') {
      return setErrors({ ...errors, name: 'Sprint name is required' });
    }
    setSaving(true);
    await addSprint(inputRef.current?.value as string, textAreaRef.current?.value as string);
    setSaving(false);
    onClose();
  };

  return (
    <form onSubmit={handleSprint}>
      <div className="p-24">
        <div className="flex justify-between mb-8">
          <span className="text-primary-700 font-semibold text-xl">Create sprint</span>
          <button type="button" aria-label="close button" onClick={onClose}>
            <CloseIcon className="text-gray-600 text-xs" />
          </button>
        </div>

        <div className="w-full mb-20">
          <label className="mb-8 block text-sm text-gray-500 font-medium">Name</label>
          <input
            autoFocus
            ref={inputRef}
            type="text"
            onChange={(e) => e.target.value && setErrors({ ...errors, name: '' })}
            className="border w-full text-base placeholder-text-gray-500 focus:shadow-outline border-gray-200 px-12 py-10 bg-gray-100 rounded-lg placeholder-text-base"
          />
          {!!errors.name && (
            <label className="mb-8 block text-sm text-red-600 font-medium">{errors.name}</label>
          )}
        </div>
        <div className="w-full mb-20">
          <label className="mb-8 block  text-sm text-gray-500 font-medium">Description</label>
          <textarea
            ref={textAreaRef}
            className="border w-full text-base placeholder-text-gray-500 focus:shadow-outline border-gray-200 px-12 py-10 bg-gray-100 rounded-lg placeholder-text-base"
          />
        </div>
        <div className="flex justify-start  w-full">
          <button
            onClick={onClose}
            className="border-blue-500 text-blue-500 border rounded-sm px-24 py-8 mr-8 w-1/2"
            type="button"
          >
            Back
          </button>
          <button
            className={` text-white border rounded-sm px-24 py-8  w-1/2 ${
              isSaving ? 'bg-blue-200' : 'bg-blue-500'
            }`}
            type="submit"
            disabled={isSaving}
          >
            Create sprint
          </button>
        </div>
      </div>
    </form>
  );
};
